import { atom } from 'jotai';
import type { Promotion } from './modules/PromotionBanner/types';

export const remotePromotion = atom<Promotion | null>(null);
